import { render, staticRenderFns } from "./ModalRealFriendChatAlert.vue?vue&type=template&id=63a9c1dc&scoped=true"
import script from "./ModalRealFriendChatAlert.vue?vue&type=script&lang=js"
export * from "./ModalRealFriendChatAlert.vue?vue&type=script&lang=js"
import style0 from "./ModalRealFriendChatAlert.vue?vue&type=style&index=0&id=63a9c1dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a9c1dc",
  null
  
)

export default component.exports